import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import DescriptionDialog from "../../components/settings/DescriptionDialog2";
import EmailCopyDialog from "../../components/settings/EmailCopyDialog";
import EmailDialog from "../../components/settings/EmailDialog";
import MollieConnectDialog from "../../components/settings/MollieConnectDialog";
import SignupSettings from "../../components/settings/SignupSettings";
import Currencies from "../../constants/Currencies";
import { languages } from "../../constants/languages";
import { isNormalInteger } from "../../util/IsNormalInteger";
import { validateEmail } from "../../util/ValidateEmail";

class SignupSettingsContainer extends Component {
  state = {
    descriptionDialogOpen: false,
    signupDescription: "",
    paymentInstructionsDialogOpen: false,
    paymentInstructions: "",
    paymentInstructions2DialogOpen: false,
    paymentInstructions2: "",
    mollieConnected: false,
    authLoaded: false,
    emailTexts: {},
    emailTextsNew: {},
    emailTextsLoaded: false,
    emailDialogOpen: false,
    mollieConnectDialogOpen: false,
    emailCopy: "",
    emailCopyDialogOpen: false,
    errorMessage: "",
    tr: null,
    trEmailTexts: null,
    trPayment: null,
    trPayment2: null,

    listsAC: {},
    listsACLoaded: false,
  };

  UNSAFE_componentWillMount = () => {
    let initialState = {
      signupDescription: this.props.tournament.signupDescription || "",
      paymentInstructions: this.props.tournament.paymentInstructions || "",
      paymentInstructions2: this.props.tournament.paymentInstructions2 || "",
    };
    languages.getAvailableLanguages().forEach((lang) => {
      initialState["signupDescription" + lang] =
        this.props.tournament["signupDescription" + lang] || "";
      initialState["paymentInstructions" + lang] =
        this.props.tournament["paymentInstructions" + lang] || "";
      initialState["paymentInstructions2" + lang] =
        this.props.tournament["paymentInstructions2" + lang] || "";
    });
    this.setState(initialState);

    this.unsubscribeAuth = window.firebase
      .firestore()
      .collection("mollieAuths")
      .doc(this.props.user.uid)
      .onSnapshot((doc) => {
        let mollieConnected = false;
        if (doc.exists) {
          let auth = doc.data();
          if (auth.mollieToken) {
            mollieConnected = true;
          }
        }
        this.setState({ mollieConnected: mollieConnected, authLoaded: true });
      });

    this.unsubscribeEmailTexts = window.firebase
      .firestore()
      .collection("signupEmailTexts")
      .doc(this.props.tournament[".key"])
      .onSnapshot((doc) => {
        let texts = {};
        let textsNew = {};
        if (doc.exists) {
          texts = doc.data();
          textsNew = doc.data();
        }
        if (this.state.emailTextsLoaded === false) {
          this.setState({
            emailTextsNew: textsNew,
            emailTextsLoaded: true,
            emailTexts: texts,
          });
        } else {
          this.setState({ emailTexts: texts });
        }
      });

    this.unsubscribeCopyEmails = window.firebase
      .firestore()
      .collection("signupCopyEmails")
      .doc(this.props.tournament[".key"])
      .onSnapshot((doc) => {
        let emailString = "";
        if (doc.exists) {
          let emailDoc = doc.data();
          emailString = emailDoc.value || "";
          this.setState({
            emailCopy: emailString || (this.props.userData || {}).email,
          });
        } else {
          this.setState({ emailCopy: (this.props.userData || {}).email });
        }
      });

    if (
      this.props.tournament.uid === "UiIJajZgHLPImDX1VIBmezMtUtU2" || // Weplay
      this.props.tournament.uid === "dLIIgYris4QH9SaFvO1fYkfWhSw2" // Jesse
    ) {
      fetch("https://tournify-server.herokuapp.com/getListsAC", {
        method: "GET",
        mode: "cors",
        headers: {
          Accept: "application/json, text/plain, */*",
          "Content-Type": "application/json",
        },
        // body: JSON.stringify({
        //   nvdCode: this.props.tournament.crq || "",
        //   tournamentId: this.props.tournament[".key"],
        // }),
      })
        .then(function (response) {
          return response.json();
        })
        .then(
          function (payload) {
            this.setState({ listsAC: payload, listsACLoaded: true });
          }.bind(this)
        );
    }
  };

  onDragEnd = (result, perSignup) => {
    if (!result.destination) {
      return;
    }

    let questions = [];
    if (perSignup) {
      questions = Object.keys(this.props.tournament.questions || {})
        .filter(
          (key) => this.props.tournament.questions[key].perSignup === true
        )
        .sort((a, b) => {
          const qA = this.props.tournament.questions[a];
          const qB = this.props.tournament.questions[b];
          if (qA.num > qB.num) {
            return 1;
          } else if (qA.num < qB.num) {
            return -1;
          } else {
            return 0;
          }
        })
        .slice();
    } else {
      questions = Object.keys(this.props.tournament.questions || {})
        .filter(
          (key) => this.props.tournament.questions[key].perSignup !== true
        )
        .sort((a, b) => {
          const qA = this.props.tournament.questions[a];
          const qB = this.props.tournament.questions[b];
          if (qA.num > qB.num) {
            return 1;
          } else if (qA.num < qB.num) {
            return -1;
          } else {
            return 0;
          }
        })
        .slice();
    }
    const [removed] = questions.splice(result.source.index, 1);
    questions.splice(result.destination.index, 0, removed);
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const newQuestions = this.props.tournament.questions;
    questions.forEach((q, i) => {
      let question = this.props.tournament.questions[q];
      question["num"] = i;
      newQuestions[q] = question;
    });
    tournamentRef.update({ questions: newQuestions }).catch((error) => {
      console.log(error.message);
    });
  };

  onDragEndProduct = (result) => {
    if (!result.destination) {
      return;
    }

    let products = Object.keys(this.props.tournament.products || {})
      .sort((a, b) => {
        const pA = this.props.tournament.products[a];
        const pB = this.props.tournament.products[b];
        if (pA.num > pB.num) {
          return 1;
        } else if (pA.num < pB.num) {
          return -1;
        } else {
          return 0;
        }
      })
      .slice();

    const [removed] = products.splice(result.source.index, 1);
    products.splice(result.destination.index, 0, removed);
    const db = window.firebase.firestore();
    const tournamentRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"]);
    const newProducts = this.props.tournament.products;
    products.forEach((q, i) => {
      let product = this.props.tournament.products[q];
      product["num"] = i;
      newProducts[q] = product;
    });
    tournamentRef.update({ products: newProducts }).catch((error) => {
      console.log(error.message);
    });
  };

  handleListACChange = (e) => {
    this.update({ listIdAC: e.target.value });
  };

  handleCurrencyChange = (e) => {
    let toUpdate = { currency: e.target.value };
    if (!Currencies[e.target.value].mollie) {
      toUpdate["onlinePayment"] = false;
    }
    this.update(toUpdate);
  };

  componentWillUnmount = () => {
    this.unsubscribeAuth();
    this.unsubscribeEmailTexts();
    this.unsubscribeCopyEmails();
  };

  update = (toUpdate) => {
    window.firebase
      .firestore()
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .update(toUpdate);
  };

  handleBack = () => {
    this.props.history.push("/tournament/" + this.props.tournament[".key"]);
  };

  handleOpenSignupChange = (e) => {
    if (window.firebase.analytics) {
      window.firebase.analytics().logEvent("open_signup_page");
    }
    const newSignupOpen = !(this.props.tournament.signupOpen || false);
    let toUpdate = { signupOpen: newSignupOpen };
    
    // When opening signup, also set email.show to true in defaultFields
    if (newSignupOpen) {
      let newDefaultFields = this.props.tournament.defaultFields || {};
      if (newDefaultFields.email === undefined) {
        newDefaultFields.email = {};
      }
      newDefaultFields.email.show = true;
      toUpdate.defaultFields = newDefaultFields;
    }
    
    this.update(toUpdate);
  };

  handleAddLoginLinkChange = (e) => {
    this.update({
      addLoginLink: !(this.props.tournament.addLoginLink || false),
    });
  };

  handleSendConfirmationChange = (e) => {
    this.update({
      sendSignupConfirmationEmail: !(
        this.props.tournament.sendSignupConfirmationEmail === undefined ||
        this.props.tournament.sendSignupConfirmationEmail
      ),
    });
  };

  handleSendCopyChange = (e) => {
    this.update({ sendCopy: !(this.props.tournament.sendCopy || false) });
  };

  toggleDescriptionDialog = () => {
    this.setState({ descriptionDialogOpen: !this.state.descriptionDialogOpen });
  };

  toggleEmailTextsDialog = () => {
    this.setState({ emailDialogOpen: !this.state.emailDialogOpen });
  };

  toggleEmailCopyDialog = () => {
    this.setState({ emailCopyDialogOpen: !this.state.emailCopyDialogOpen });
  };

  toggleMollieConnectDialog = () => {
    this.setState({
      mollieConnectDialogOpen: !this.state.mollieConnectDialogOpen,
    });
  };

  togglePaymentInstructionsDialog = () => {
    this.setState({
      paymentInstructionsDialogOpen: !this.state.paymentInstructionsDialogOpen,
    });
  };

  togglePaymentInstructions2Dialog = () => {
    this.setState({
      paymentInstructions2DialogOpen:
        !this.state.paymentInstructions2DialogOpen,
    });
  };

  handleDescriptionTrChange = (tr) => {
    this.setState({ tr: tr });
  };
  handlePaymentTrChange = (tr) => {
    this.setState({ trPayment: tr });
  };
  handlePayment2TrChange = (tr) => {
    this.setState({ trPayment2: tr });
  };

  handleEmailTextsTrChange = (tr) => {
    this.setState({ trEmailTexts: tr });
  };

  handleDescriptionChange = (e) => {
    let description = e.target.value.replace(/\n/g, "<br />");
    let toUpdate = {};
    toUpdate["signupDescription" + (this.state.tr ? this.state.tr : "")] =
      description;
    this.setState(toUpdate);
  };

  handleSubmitDescription = (e) => {
    e.preventDefault();
    this.toggleDescriptionDialog();
    let toUpdate = {};
    toUpdate["signupDescription" + (this.state.tr ? this.state.tr : "")] =
      this.state["signupDescription" + (this.state.tr ? this.state.tr : "")];
    this.update(toUpdate);
  };

  handleEmailTextsChange = (e) => {
    let emailTexts = this.state.emailTextsNew;
    emailTexts[
      e.target.name + (this.state.trEmailTexts ? this.state.trEmailTexts : "")
    ] = e.target.value.replace(/\n/g, "<br />");
    this.setState({ emailTextsNew: emailTexts });
  };

  handleSubmitEmailTexts = (e) => {
    e.preventDefault();
    this.toggleEmailTextsDialog();
    window.firebase
      .firestore()
      .collection("signupEmailTexts")
      .doc(this.props.tournament[".key"])
      .set(this.state.emailTextsNew);
  };

  handleEmailCopyChange = (e) => {
    this.setState({ emailCopy: e.target.value });
  };

  handleSubmitEmailCopy = (e) => {
    e.preventDefault();
    if (validateEmail(this.state.emailCopy) || this.state.emailCopy === "") {
      this.toggleEmailCopyDialog();
      this.setState({ errorMessage: "" });
      window.firebase
        .firestore()
        .collection("signupCopyEmails")
        .doc(this.props.tournament[".key"])
        .set({ value: this.state.emailCopy });
    } else {
      let errorMessage = languages.login.invalidEmail;
      this.setState({ errorMessage: errorMessage });
    }
  };

  handleTotalSignupsChange = (e) => {
    let newValue = e.target.value;
    if (isNormalInteger(newValue) || newValue === "") {
      this.update({ totalSignups: newValue });
    }
  };

  handleSignupPriceChange = (e) => {
    if (
      this.isValidPrice(e.target.value) ||
      isNormalInteger(e.target.value) ||
      e.target.value === ""
    ) {
      this.update({ signupPrice: e.target.value });
    }
  };

  isValidPrice = (str) => {
    // eslint-disable-next-line
    return /^\d+(?:\,\d{0,2})$/.test(str);
  };

  handleDivisionSignupsChange = (e) => {
    let newValue = e.target.value;
    if (isNormalInteger(newValue) || newValue === "") {
      const divisionId = e.target.name;
      let divisionSignups = this.props.tournament.divisionSignups || {};
      divisionSignups[divisionId] = newValue;
      this.update({ divisionSignups: divisionSignups });
    }
  };

  handlePricePerDivisionCheck = (e) => {
    this.update({
      pricePerDivision: !(this.props.tournament.pricePerDivision || false),
    });
  };

  handleTeamSignupQuestion2Check = (e) => {
    this.update({
      showTeamSignupQuestion2: !(
        this.props.tournament.showTeamSignupQuestion2 || false
      ),
    });
  };

  handleIndividualPlayersQuestionCheck = (e) => {
    this.update({
      showIndividualPlayersSignupQuestion: !(
        this.props.tournament.showIndividualPlayersSignupQuestion || false
      ),
    });
  };

  handleShowCountrySignupQuestionCheck = (e) => {
    this.update({
      showCountrySignupQuestion: !(
        this.props.tournament.showCountrySignupQuestion || false
      ),
    });
  };

  handleShowLogoSignupQuestionCheck = (e) => {
    this.update({
      showLogoSignupQuestion: !(
        this.props.tournament.showLogoSignupQuestion || false
      ),
    });
  };

  handleAllowMultipleSignupsChange = (e) => {
    this.update({
      allowMultipleSignups: !(
        this.props.tournament.allowMultipleSignups === undefined ||
        this.props.tournament.allowMultipleSignups ||
        false
      ),
    });
  };

  handleDivisionSignupPriceChange = (e) => {
    let newValue = e.target.value;
    if (
      this.isValidPrice(newValue) ||
      isNormalInteger(newValue) ||
      newValue === ""
    ) {
      const divisionId = e.target.name;
      let divisionSignupPrice = this.props.tournament.divisionSignupPrice || {};
      divisionSignupPrice[divisionId] = newValue;
      this.update({ divisionSignupPrice: divisionSignupPrice });
    }
  };

  handlePaymentMethodChange = (e) => {
    let toUpdate = {};
    toUpdate[e.target.name] = !(this.props.tournament[e.target.name] || false);
    this.update(toUpdate);
  };

  handlePaymentInstructionsChange = (e) => {
    let paymentInstructions = e.target.value.replace(/\n/g, "<br />");
    let toUpdate = {};
    toUpdate[
      "paymentInstructions" + (this.state.trPayment ? this.state.trPayment : "")
    ] = paymentInstructions;
    this.setState(toUpdate);
  };

  handlePaymentInstructions2Change = (e) => {
    let paymentInstructions = e.target.value.replace(/\n/g, "<br />");
    let toUpdate = {};
    toUpdate[
      "paymentInstructions2" +
        (this.state.trPayment2 ? this.state.trPayment2 : "")
    ] = paymentInstructions;
    this.setState(toUpdate);
  };

  handleSubmitPaymentInstructions = (e) => {
    e.preventDefault();
    this.togglePaymentInstructionsDialog();
    let toUpdate = {};
    toUpdate[
      "paymentInstructions" + (this.state.trPayment ? this.state.trPayment : "")
    ] =
      this.state[
        "paymentInstructions" +
          (this.state.trPayment ? this.state.trPayment : "")
      ];
    this.update(toUpdate);
  };

  handleSubmitPaymentInstructions2 = (e) => {
    e.preventDefault();
    this.togglePaymentInstructions2Dialog();
    let toUpdate = {};
    toUpdate[
      "paymentInstructions2" +
        (this.state.trPayment2 ? this.state.trPayment2 : "")
    ] =
      this.state[
        "paymentInstructions2" +
          (this.state.trPayment2 ? this.state.trPayment2 : "")
      ];
    this.update(toUpdate);
  };

  handleMollieConnectClick = (e) => {
    let url = "https://www.mollie.com/oauth2/authorize?";

    var randomState = "";
    var possible =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < 5; i++)
      randomState += possible.charAt(
        Math.floor(Math.random() * possible.length)
      );

    let clientId = "app_hbAxzvxxBcwfE4sEqsJFNhbd";

    if (
      ((window.location.hostname || "").split(".") || [])[
        ((window.location.hostname || "").split(".") || []).length - 1
      ] === "be"
    ) {
      clientId = "app_CJfJ476v9Nst6fmwEQ8zv6uq";
    }

    if (
      ((window.location.hostname || "").split(".") || [])[
        ((window.location.hostname || "").split(".") || []).length - 1
      ] === "com"
    ) {
      clientId = "app_4NFpHzukyFUN3VHxDfp83WAH";
    }

    if (
      ((window.location.hostname || "").split(".") || [])[
        ((window.location.hostname || "").split(".") || []).length - 1
      ] === "de"
    ) {
      clientId = "app_Ms2vzNWu4Mugh4F5TuUA8uz9";
    }

    if (
      ((window.location.hostname || "").split(".") || [])[
        ((window.location.hostname || "").split(".") || []).length - 1
      ] === "fr"
    ) {
      clientId = "app_ykRh7EVbANSKxGP2GuatrFW4";
    }

    if (
      ((window.location.hostname || "").split(".") || [])[
        ((window.location.hostname || "").split(".") || []).length - 1
      ] === "es"
    ) {
      clientId = "app_2A7HHfN4sVk8n44ACHb35EDU";
    }

    if (
      ((window.location.hostname || "").split(".") || [])[
        ((window.location.hostname || "").split(".") || []).length - 1
      ] === "uk"
    ) {
      clientId = "app_HpgHyJkvbR2TChTayFRGRbxU";
    }

    var params = {
      client_id: clientId,
      state: randomState,
      scope: "payments.read payments.write profiles.read",
      response_type: "code",
      approval_prompt: "auto",
    };

    var esc = encodeURIComponent;
    var query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");

    let authorization = {
      redirectURL: window.location.href,
      hostname: window.location.hostname,
      clientId: clientId,
      randomState: randomState,
    };

    var newAuth = window.firebase
      .firestore()
      .collection("mollieAuths")
      .doc(this.props.user.uid);
    newAuth.set(authorization).then(() => {
      window.location = url + query;
    });
  };

  render() {
    // let maxTeamsPlaceholder = "";
    // if (
    //   this.props.tournamentStatus.status === 2 ||
    //   this.props.userStatus.status === 2
    // ) {
    //   maxTeamsPlaceholder = languages.signupPage.unlimited;
    // } else if (
    //   this.props.tournamentStatus.status === 1 ||
    //   this.props.userStatus.status === 1
    // ) {
    //   maxTeamsPlaceholder = "60";
    // }
    return (
      <div>
        <DescriptionDialog
          open={this.state.descriptionDialogOpen}
          description={
            this.state.tr
              ? this.state["signupDescription" + this.state.tr]
              : this.state.signupDescription
          }
          toggleDialog={this.toggleDescriptionDialog}
          handleDescriptionChange={this.handleDescriptionChange}
          handleSubmit={this.handleSubmitDescription}
          title={languages.signupPage.description}
          tr={this.state.tr}
        />
        <DescriptionDialog
          open={this.state.paymentInstructionsDialogOpen}
          description={
            this.state.trPayment
              ? this.state["paymentInstructions" + this.state.trPayment]
              : this.state.paymentInstructions
          }
          toggleDialog={this.togglePaymentInstructionsDialog}
          handleDescriptionChange={this.handlePaymentInstructionsChange}
          handleSubmit={this.handleSubmitPaymentInstructions}
          title={languages.signupPage.manualPayment}
          tr={this.state.trPayment}
        />
        <DescriptionDialog
          open={this.state.paymentInstructions2DialogOpen}
          description={
            this.state.trPayment2
              ? this.state["paymentInstructions2" + this.state.trPayment2]
              : this.state.paymentInstructions2
          }
          toggleDialog={this.togglePaymentInstructions2Dialog}
          handleDescriptionChange={this.handlePaymentInstructions2Change}
          handleSubmit={this.handleSubmitPaymentInstructions2}
          title={languages.signupPage.manualPayment}
          tr={this.state.trPayment2}
        />
        <EmailDialog
          open={this.state.emailDialogOpen}
          emailTexts={this.state.emailTextsNew}
          toggleDialog={this.toggleEmailTextsDialog}
          handleChange={this.handleEmailTextsChange}
          handleSubmit={this.handleSubmitEmailTexts}
          title={languages.signupPage.confirmationEmail}
          trEmailTexts={this.state.trEmailTexts}
          tournament={this.props.tournament}
        />
        <EmailCopyDialog
          open={this.state.emailCopyDialogOpen}
          emailCopy={this.state.emailCopy}
          toggleDialog={this.toggleEmailCopyDialog}
          handleChange={this.handleEmailCopyChange}
          handleSubmit={this.handleSubmitEmailCopy}
          title={languages.signupPage.confirmationEmailCopy}
          errorMessage={this.state.errorMessage}
        />
        <MollieConnectDialog
          open={this.state.mollieConnectDialogOpen}
          toggleDialog={this.toggleMollieConnectDialog}
          handleMollieConnectClick={this.handleMollieConnectClick}
          mollieConnected={this.state.mollieConnected}
          authLoaded={this.state.authLoaded}
        />
        <SignupSettings
          tournament={this.props.tournament}
          handleOpenSignupChange={this.handleOpenSignupChange}
          toggleDescriptionDialog={this.toggleDescriptionDialog}
          // maxTeamsPlaceholder={maxTeamsPlaceholder}
          handleTotalSignupsChange={this.handleTotalSignupsChange}
          handleDivisionSignupsChange={this.handleDivisionSignupsChange}
          handleSignupPriceChange={this.handleSignupPriceChange}
          handlePricePerDivisionCheck={this.handlePricePerDivisionCheck}
          handleDivisionSignupPriceChange={this.handleDivisionSignupPriceChange}
          handlePaymentMethodChange={this.handlePaymentMethodChange}
          paymentInstructions={this.state.paymentInstructions}
          togglePaymentInstructionsDialog={this.togglePaymentInstructionsDialog}
          handlePaymentInstructionsChange={this.handlePaymentInstructionsChange}
          paymentInstructions2={this.state.paymentInstructions2}
          togglePaymentInstructions2Dialog={
            this.togglePaymentInstructions2Dialog
          }
          handlePaymentInstructions2Change={
            this.handlePaymentInstructions2Change
          }
          divisions={this.props.divisions}
          handleBack={this.handleBack}
          mollieConnected={this.state.mollieConnected}
          authLoaded={this.state.authLoaded}
          handleSendCopyChange={this.handleSendCopyChange}
          handleSendConfirmationChange={this.handleSendConfirmationChange}
          toggleEmailTextsDialog={this.toggleEmailTextsDialog}
          emailTexts={this.state.emailTexts}
          toggleMollieConnectDialog={this.toggleMollieConnectDialog}
          tournamentAdmin={this.props.tournamentAdmin}
          handleAddLoginLinkChange={this.handleAddLoginLinkChange}
          emailCopy={this.state.emailCopy || (this.props.userData || {}).email}
          toggleEmailCopyDialog={this.toggleEmailCopyDialog}
          tr={this.state.tr}
          handleDescriptionTrChange={this.handleDescriptionTrChange}
          trEmailTexts={this.state.trEmailTexts}
          handleEmailTextsTrChange={this.handleEmailTextsTrChange}
          trPayment={this.state.trPayment}
          trPayment2={this.state.trPayment2}
          handlePaymentTrChange={this.handlePaymentTrChange}
          handlePayment2TrChange={this.handlePayment2TrChange}
          handleTeamSignupQuestion2Check={this.handleTeamSignupQuestion2Check}
          handleIndividualPlayersQuestionCheck={
            this.handleIndividualPlayersQuestionCheck
          }
          handleShowCountrySignupQuestionCheck={
            this.handleShowCountrySignupQuestionCheck
          }
          handleAllowMultipleSignupsChange={
            this.handleAllowMultipleSignupsChange
          }
          handleShowLogoSignupQuestionCheck={
            this.handleShowLogoSignupQuestionCheck
          }
          handleCurrencyChange={this.handleCurrencyChange}
          // weplay
          listsAC={this.state.listsAC}
          listsACLoaded={this.state.listsACLoaded}
          handleListACChange={this.handleListACChange}
          onDragEnd={this.onDragEnd}
          onDragEndProduct={this.onDragEndProduct}
        />
      </div>
    );
  }
}

export default withRouter(SignupSettingsContainer);
